import request from '../utils/http'
// 设备列表
export function index (query) {
  return request({
    url: '/device/list',
    method: 'GET',
    params: query
  })
}
// 新增设备
export function save (query) {
  return request({
    url: '/device/save',
    method: 'POST',
    data: query
  })
}
// 编辑设备
export function edit (query) {
  return request({
    url: '/device/edit',
    method: 'GET',
    params: query
  })
}
// 更新设备
export function update (query) {
  return request({
    url: '/device/update',
    method: 'POST',
    data: query
  })
}
// 删除设备
export function del (query) {
  return request({
    url: '/device/delete',
    method: 'DELETE',
    data: query
  })
}
// 设备开关
export function show (query) {
  return request({
    url: '/device/show',
    method: 'POST',
    data: query
  })
}
// 导出设备数据
export function deviceExport (query) {
  return request({
    url: '/device/export',
    method: 'POST',
    responseType: 'blob',
    data: query
  })
}
// 设备开关
export function active (query) {
  return request({
    url: '/device/active',
    method: 'POST',
    data: query
  })
}
// 校区列表
export function campusList (query) {
  return request({
    url: '/campus/list?limit=500',
    method: 'GET',
    params: query
  })
}
// 机构列表
export function mechanismList (query) {
  return request({
    url: '/mechanism/list?limit=500&is_show=1',
    method: 'GET',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/device.js